module.exports = __webpack_public_path__ + "media/packs/static/fonts/interUI/bold-070050d95eb626de5c2ff70a60eb5fbf.woff2";